<template>
  <div class="jackpot-wrapper" :class="{ 'is-mobile': isMobile }">
    <div class="toggle-btns" :class="{ 'is-mobile': isMobile }">
      <div :class="{ active: activeContent === 'current' }" @click="toggleActiveContent('current')">
        {{ $t('Current jackpot') }}
      </div>
      <div :class="{ active: activeContent === 'past' }" @click="toggleActiveContent('past')">
        {{ $t('Past winner') }}
      </div>
    </div>
    <div class="jackpot-scroll-body" :class="{ 'is-mobile': isMobile }">
      <div class="jackpot-info" :class="{ 'is-mobile': isMobile }">
        <div class="left">
          <template v-if="activeContent === 'current'">
            <Badge :badgeType="'major'" :width="140">
              <template v-slot:main v-if="!withCommission">
                {{ currencySymbol }} {{ formatAmountWithKM(Math.floor(Number(majorTicket.jackpotAmount)), 0) }}
              </template>
              <template v-slot:main v-else>
                {{ $t('Win') }}
              </template>
              <template v-slot:type> major </template>
            </Badge>
            <Badge :badgeType="'minor'" :width="120" :height="44">
              <template v-slot:main v-if="!withCommission">
                {{ currencySymbol }} {{ formatAmountWithKM(Math.floor(Number(minorTicket.jackpotAmount)), 0) }}
              </template>
              <template v-slot:main v-else>
                {{ $t('Win') }}
              </template>
              <template v-slot:type> minor </template>
            </Badge>
            <Badge :badgeType="'mini'" :width="100" :height="38">
              <template v-slot:main v-if="!withCommission">
                {{ currencySymbol }} {{ formatAmountWithKM(Math.floor(Number(miniTicket.jackpotAmount)), 0) }}
              </template>
              <template v-slot:main v-else>
                {{ $t('Win') }}
              </template>
              <template v-slot:type> mini </template>
            </Badge>
          </template>
          <template v-else>
            <div class="my-tickets">
              <div class="header">{{ $t('My tickets') }}</div>
              <div class="major-tickets tickets">
                <img src="@/assets/images/major-ticket.webp" />
                <span class="text"> x{{ ownerPastMajorTicketsCount }} </span>
              </div>
              <div class="minor-tickets tickets">
                <img src="@/assets/images/minor-ticket.webp" />
                <span class="text"> x{{ ownerPastMinorTicketsCount }} </span>
              </div>
              <div class="mini-tickets tickets">
                <img src="@/assets/images/mini-ticket.webp" />
                <span class="text"> x{{ ownerPastMiniTicketsCount }} </span>
              </div>
            </div>
          </template>
        </div>
        <div class="right" :class="{ past: activeContent === 'past' }">
          <div class="super-draw-no">
            <div class="supper-draw-info">
              <div class="super-draw-label">
                {{ $t($capitalize(currentLuckyDraw.name, true)) }}
              </div>
              <div class="super-draw-number">
                No. {{ activeContent === 'past' ? currentLuckyDraw.drawNum - 1 : currentLuckyDraw.drawNum }}
              </div>
            </div>
            <div class="super-draw-img">
              <img v-if="activeContent === 'current'" src="@/assets/images/super-draw.webp" />
              <img v-else src="@/assets/images/super-draw-past.webp" />
            </div>
          </div>
          <CountdownWrapper
            v-if="activeContent === 'current'"
            :timerHour="timerHour"
            :timerMinite="timerMinite"
            :timerSecond="timerSecond"
          />
        </div>
      </div>
      <div class="record">
        <div class="header">
          <template v-if="activeContent === 'current'">
            <div class="left">
              {{ $t('My tickets') }}
            </div>
            <div class="right">
              <div class="major-tickets tickets">
                <img src="@/assets/images/major-ticket.webp" />
                <span class="text"> x{{ ownerCurrentMajorTicketsCount }} </span>
              </div>
              <div class="minor-tickets tickets">
                <img src="@/assets/images/minor-ticket.webp" />
                <span class="text"> x{{ ownerCurrentMinorTicketsCount }} </span>
              </div>
              <div class="mini-tickets tickets">
                <img src="@/assets/images/mini-ticket.webp" />
                <span class="text"> x{{ ownerCurrentMiniTicketsCount }} </span>
              </div>
            </div>
          </template>
          <template v-else>{{ $t('Winners') }}</template>
        </div>
        <div class="body">
          <template v-if="activeContent === 'current'">
            <div class="progress-to-next">
              <div class="label">{{ $t('Progress') }}</div>
              <div class="progress-bar-wrapper">
                <progress-bar
                  :diameter="200"
                  :completed-steps="progressVal"
                  :total-steps="100"
                  innerStrokeColor="#d9d8d8"
                  startColor="#f9cf6b"
                  stopColor="#f9cf6b"
                  :showTip="false"
                  :height="4"
                  :animateSpeed="1000"
                >
                </progress-bar>

                <div class="progress-milestone-coin zero" v-if="progressVal > 0">
                  <img src="@/assets/images/coin.webp" />
                </div>
                <div class="progress-milestone-coin one" v-if="progressVal > 25">
                  <img src="@/assets/images/coin.webp" />
                </div>
                <div class="progress-milestone-coin two" v-if="progressVal > 50">
                  <img src="@/assets/images/coin.webp" />
                </div>
                <div class="progress-milestone-coin three" v-if="progressVal > 75">
                  <img src="@/assets/images/coin.webp" />
                </div>
              </div>
              <!-- <div class="label">{{ progressVal || 0 }}%</div> -->
              <div class="amount-track">{{ currentAmount }} / {{ nextTicketAmount }}</div>
            </div>
            <div class="ticket-logs" :class="{ landscape: isMobileLandscape }">
              <JackpotLogs
                :logTickets="ownerCurrentTicketsLog"
                :ticketsLength="ownerCurrentTicketsLog.length || 0"
                @loadMoreTickets="loadMoreTickets"
              />
            </div>
          </template>
          <template v-else>
            <div class="winner-logs" :class="{ landscape: isMobileLandscape }">
              <div class="major winner-row">
                <div class="badge">
                  <Badge :badgeType="'major'" :width="140">
                    <template v-slot:main v-if="!withCommission">
                      {{ currencySymbol }} {{ formatAmountWithKM(Number(majorWinner.amount), 0) }}
                    </template>
                    <template v-slot:main v-else>
                      {{ $t('Win') }}
                    </template>
                    <template v-slot:type> major </template>
                  </Badge>
                </div>
                <div class="info-list">
                  <div class="info" :class="{ isMe: majorWinner.isMe }">
                    <div class="name">
                      {{ majorWinner.isMe ? majorWinner.displayName : getWildCardName(majorWinner.displayName) }}
                    </div>
                    <div class="id">
                      {{ majorWinner.sid }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="minor winner-row">
                <div class="badge">
                  <Badge :badgeType="'minor'" :width="120">
                    <template v-slot:main v-if="!withCommission">
                      {{ currencySymbol }} {{ formatAmountWithKM(Number(minorWinners[0].amount), 0) }}
                    </template>
                    <template v-slot:main v-else>
                      {{ $t('Win') }}
                    </template>
                    <template v-slot:type> minor </template>
                  </Badge>
                </div>
                <div class="info-list">
                  <div
                    class="info"
                    :class="{ isMe: minorInfo.isMe }"
                    v-for="minorInfo in minorWinners"
                    :key="minorInfo.id"
                  >
                    <div class="name">
                      {{ minorInfo.isMe ? minorInfo.displayName : getWildCardName(minorInfo.displayName) }}
                    </div>
                    <div class="id">
                      {{ minorInfo.sid }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="mini winner-row">
                <div class="badge">
                  <Badge :badgeType="'mini'">
                    <template v-slot:main v-if="!withCommission">
                      {{ currencySymbol }} {{ formatAmountWithKM(Number(miniWinners[0].amount), 0) }}
                    </template>
                    <template v-slot:main v-else>
                      {{ $t('Win') }}
                    </template>
                    <template v-slot:type> mini </template>
                  </Badge>
                </div>
                <div class="info-list">
                  <div class="info" :class="{ isMe: miniInfo.isMe }" v-for="miniInfo in miniWinners" :key="miniInfo.id">
                    <div class="name">
                      {{ miniInfo.isMe ? miniInfo.displayName : getWildCardName(miniInfo.displayName) }}
                    </div>
                    <div class="id">
                      {{ miniInfo.sid }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
    <BurgerMenu v-if="isMobile" />
  </div>
</template>
<script>
import Badge from '@/components/jackpot/ticket-badge.vue';
import { mapGetters, mapActions } from 'vuex';
import { cloneDeep, find } from 'lodash';
import ProgressBar from 'vue2-progress-bar';
import CountdownWrapper from '@/components/jackpot/jackpot-countdown';
import BurgerMenu from '@/components/burger-menu.vue';
import { isMobile } from 'mobile-device-detect';
import { formatAmountWithKM, mathFloor } from '@/utils/helpers';
import JackpotLogs from '@/components/jackpot/ticket-logs.vue';
import { Orientation } from '@/utils/index.model';

export default {
  components: {
    Badge,
    ProgressBar,
    CountdownWrapper,
    BurgerMenu,
    JackpotLogs,
  },
  data: () => {
    return {
      activeContent: 'current',
      timer: 0,
      timerHour: '00',
      timerMinite: '00',
      timerSecond: '00',
      timerInterval: null,
      isMobile,
      formatAmountWithKM,
    };
  },
  computed: {
    ...mapGetters('jackpot', [
      'pastWinners',
      'currentLuckyDrawTickets',
      'curentOwnerLuckyDrawTickets',
      'currentLuckyDraw',
      'currentInstantPrize',
      'ownerLuckyDrawTickets',
      'ownerTicketsLog',
      'pastOwnerTickets',
      'ticketPagination',
    ]),
    ...mapGetters('general', ['member', 'withCommission']),
    currencySymbol() {
      return this.member.currencySymbol;
    },
    isMobileLandscape() {
      return isMobile && this.$screen.orientation === Orientation.landscape;
    },
    majorWinner() {
      console.log(this.pastWinners);
      return this.pastWinners[0];
    },
    minorWinners() {
      const temp = cloneDeep(this.pastWinners);
      return temp.splice(1, 3);
    },
    miniWinners() {
      const temp = cloneDeep(this.pastWinners);
      return temp.splice(4, 8);
    },
    majorTicket() {
      return find(this.currentLuckyDrawTickets, (ticket) => ticket.color === 'red') || {};
    },
    minorTicket() {
      return find(this.currentLuckyDrawTickets, (ticket) => ticket.color === 'green') || {};
    },
    miniTicket() {
      return find(this.currentLuckyDrawTickets, (ticket) => ticket.color === 'blue') || {};
    },
    ownerCurrentMajorTicketsCount() {
      if (!this.curentOwnerLuckyDrawTickets) return 0;
      return (this.curentOwnerLuckyDrawTickets.filter((ticket) => ticket.jackpotTicket.color === 'red') || {}).length;
    },
    ownerCurrentMinorTicketsCount() {
      if (!this.curentOwnerLuckyDrawTickets) return 0;
      return (this.curentOwnerLuckyDrawTickets.filter((ticket) => ticket.jackpotTicket.color === 'green') || {}).length;
    },
    ownerCurrentMiniTicketsCount() {
      if (!this.curentOwnerLuckyDrawTickets) return 0;
      return (this.curentOwnerLuckyDrawTickets.filter((ticket) => ticket.jackpotTicket.color === 'blue') || {}).length;
    },
    ownerPastMajorTicketsCount() {
      if (!this.pastOwnerTickets) return 0;
      return (this.pastOwnerTickets.filter((ticket) => ticket.jackpotTicket.color === 'red') || {}).length;
    },
    ownerPastMinorTicketsCount() {
      if (!this.pastOwnerTickets) return 0;
      return (this.pastOwnerTickets.filter((ticket) => ticket.jackpotTicket.color === 'green') || {}).length;
    },
    ownerPastMiniTicketsCount() {
      if (!this.pastOwnerTickets) return 0;
      return (this.pastOwnerTickets.filter((ticket) => ticket.jackpotTicket.color === 'blue') || {}).length;
    },
    progressVal() {
      return mathFloor(
        (this.currentLuckyDraw.memberCurrentAmount / this.currentLuckyDraw.memberNextTicketAmount) * 100
      );
    },
    currentAmount() {
      return formatAmountWithKM(Number(this.currentLuckyDraw.memberCurrentAmount || 0), 3);
    },
    nextTicketAmount() {
      return formatAmountWithKM(Number(this.currentLuckyDraw.memberNextTicketAmount || 0), 3);
    },
    ownerCurrentTicketsLog() {
      return this.ownerTicketsLog.filter((t) =>
        [this.currentLuckyDraw.id, this.currentInstantPrize.id].includes(t.jackpot.id)
      );
    },
  },
  methods: {
    ...mapActions('jackpot', ['getOwnerTicketsLog']),
    loadMoreTickets() {
      this.getOwnerTicketsLog();
    },
    toggleActiveContent(target) {
      this.activeContent = target;
    },
    getWildCardName(name) {
      return `****${name.substr(name.length - 4)}`;
    },
    updateTimer() {
      const timerHourTemp = mathFloor(this.timer / 3600);
      const timerHourRemain = mathFloor(this.timer % 3600);
      const timerMinTemp = mathFloor(timerHourRemain / 60);
      const timerSecTemp = mathFloor(timerHourRemain % 60);

      this.timerHour = timerHourTemp < 10 ? `0${timerHourTemp}` : timerHourTemp.toString();
      this.timerMinite = timerMinTemp < 10 ? `0${timerMinTemp}` : timerMinTemp.toString();
      this.timerSecond = timerSecTemp < 10 ? `0${timerSecTemp}` : timerSecTemp.toString();
    },
  },
  watch: {
    activeContent: {
      handler(newVal) {
        if (newVal === 'current') {
          this.timer = (new Date(this.currentLuckyDraw.endDateTime).getTime() - new Date().getTime()) / 1000;
          if (this.timer > 0) {
            this.updateTimer();
            if (this.timerInterval) {
              clearInterval(this.timerInterval);
              this.timerInterval = null;
            }
            this.timerInterval = setInterval(() => {
              if (this.timer > 0) {
                this.timer = this.timer - 1;
                this.updateTimer();
              }
            }, 1000);
          }
        } else {
          this.timer = 0;
          this.timerHour = '00';
          this.timerMinite = '00';
          this.timerSecond = '00';
        }
      },
      immediate: true,
    },
  },
  beforeDestroy() {
    clearInterval(this.timerInterval);
    this.timerInterval = null;
  },
};
</script>
<style lang="scss" scoped>
.jackpot-wrapper {
  height: 100%;
  width: 100%;
  padding: 24px 16px;
  box-sizing: border-box;
  background-color: #142f4b;

  &.is-mobile {
    padding: 0;
  }

  .toggle-btns {
    width: 100%;
    overflow: hidden;
    border-radius: 8px;
    background-color: #07182c;
    display: flex;
    justify-content: space-around;

    & > div {
      cursor: pointer;
      color: #b2d6ea;
      font-size: 13px;
      font-weight: 600;
      flex: 1;
      text-transform: uppercase;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;

      &.active {
        color: #fff;
        border-radius: 8px;
        box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
        background-image: linear-gradient(96deg, #0073e8 3%, #1a5176 97%);
      }
    }

    &.is-mobile > div {
      height: 32px;
    }
  }

  .jackpot-scroll-body {
    overflow: hidden;
    height: calc(100% - 96px);
    display: flex;
    flex-direction: column;

    &.is-mobile {
      height: calc(100% - 40px);
    }
  }

  .jackpot-info {
    height: 200px;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    padding: 16px 0;
    box-sizing: border-box;

    &.is-mobile {
      padding: 8px;
      height: 170px;
    }
    .left {
      display: flex;
      flex: 1;
      flex-direction: column;
      justify-content: center;

      > div {
        margin-top: 10px;
        &:first-of-type {
          margin-top: 0;
        }
      }
      .my-tickets {
        height: 170px;
        width: calc(100% - 20px);
        display: flex;
        flex-direction: column;
        border-radius: 8px;
        background-color: #314b66;
        justify-content: space-around;
        align-items: center;
        
        font-size: 14px;
        font-weight: 600;
        text-align: left;
        color: #fff;

        .header {
          
          font-size: 14px;
          text-align: center;
          color: #fff;
          text-transform: uppercase;
        }
        .tickets {
          display: flex;
          flex-direction: row;
          justify-content: space-evenly;
          align-items: center;
          width: 100%;
          img {
            height: 24px;
          }
        }
      }
    }
    .right {
      display: flex;
      flex: 1;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      border-radius: 8px;
      padding: 12px 16px;
      box-sizing: border-box;
      background-image: linear-gradient(to top, #b2cdff -24%, #46aafc 107%);
      .super-draw {
        &-no {
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          text-transform: uppercase;
          max-width: 200px;
        }

        &-info {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          flex: 1;
        }
        &-label {
          font-size: 20px;
          font-weight: 600;
          text-align: left;
          color: #fff;
          white-space: normal;
        }

        &-number {
          display: flex;
          width: 56px;
          height: 20px;
          padding: 2px 6px;
          box-sizing: border-box;
          border-radius: 20px;
          background-color: #fff;
          font-size: 13px;
          font-weight: 600;
          color: #2e4c57;
          justify-content: center;
          align-items: center;
          flex-wrap: nowrap;
          white-space: nowrap;
        }

        &-img {
          max-width: 50%;
          box-sizing: border-box;

          img {
            max-width: 100%;
          }
        }
      }

      .countdown {
        text-shadow: 0 2px 0 rgba(0, 0, 0, 0.2);
        
        font-size: 20px;
        font-weight: 600;
        text-align: center;
        color: #fff;
      }

      &.past {
        background-image: linear-gradient(to top, #9fd59b -24%, #5ca269 107%);

        .supper-draw-info {
          display: flex;
          flex-direction: column;
          justify-content: space-evenly;
          height: 100%;
        }
        .text {
          background-image: linear-gradient(to left, rgba(36, 31, 32, 0) 100%, #a29193 53%, rgba(36, 31, 32, 0) 5%);
        }
      }
    }
  }

  .record {
    width: 100%;
    display: flex;
    flex-direction: column;
    flex: 1;
    .header {
      width: 100%;
      height: 40px;
      padding: 0 16px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      background-image: linear-gradient(93deg, #0073e8 3%, #1a5176 98%);
      font-size: 14px;
      color: #fff;
      text-transform: uppercase;
      box-sizing: border-box;
      border-radius: 8px 8px 0 0;

      .right {
        display: flex;
        .tickets {
          display: flex;
          align-items: center;
          margin-right: 5px;
          margin-left: 10px;

          &:last-of-type {
            margin-right: 0;
          }
          img {
            height: 20px;
            margin-right: 4px;
          }
        }
      }
    }
    .body {
      background-color: #07182c;
      display: flex;
      flex-direction: column;
      flex: 1;
      min-height: 200px;

      .progress-to-next {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        padding: 12px 16px;
        box-sizing: border-box;

        .progress-bar-wrapper {
          display: flex;
          flex: 6;
          position: relative;
          .progress-container {
            width: 100% !important;
          }
          .progress-milestone-coin {
            position: absolute;
            transform: translateX(-8px);

            &.zero {
              left: 0;
              top: -8px;
            }
            &.one {
              left: 25%;
              top: -8px;
            }
            &.two {
              left: 50%;
              top: -8px;
            }
            &.three {
              left: 75%;
              top: -8px;
            }

            img {
              height: 24px;
            }
          }
        }

        .label {
          display: flex;
          flex: 1;
          font-size: 10px;
          font-weight: 600;
          color: #fff;
          text-transform: uppercase;
          margin-right: 8px;
        }
        .amount-track {
          display: flex;
          flex: 2;
          font-size: 12px;
          color: #759fb5;
          flex-wrap: nowrap;
          min-width: 120px;
          width: 100%;
          justify-content: flex-end;
        }
      }

      .ticket-logs {
        overflow: hidden;
        padding: 5px 16px;
        box-sizing: border-box;
        height: 190px;
        display: flex;
        flex-direction: column;
        font-size: 12px;
        color: #b2d6ea;

        &.landscape {
          height: 80px;
        }
      }

      .winner-logs {
        overflow-x: hidden;
        overflow-y: auto;
        padding: 16px;
        box-sizing: border-box;
        height: 200px;

        &.landscape {
          height: 120px;
        }
        .winner-row {
          width: 100%;
          padding: 8px 0;
          box-sizing: border-box;
          display: flex;
          flex-direction: row;
          
          flex-wrap: nowrap;

          font-weight: 600;
          color: #b2d6ea;
          .badge {
            margin-right: 10px;
          }

          .info-list {
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            flex-wrap: wrap;
            align-items: center;

            .info {
              margin-right: 5px;
              &.isMe {
                color: #fff;
              }
            }
          }

          &.major {
            font-size: 16px;

            .id {
              font-size: 12px;
            }
          }

          &.minor {
            font-size: 12px;
            flex: 4;
            .id {
              font-size: 9px;
            }
          }

          &.mini {
            font-size: 10px;
            flex: 3;
            .id {
              font-size: 9px;
            }
          }
        }
      }
    }
  }
}
</style>
